import axios from 'axios';
import errorHandlerFactory from './errorHandler';

const loadError = thingToLoad => errorHandlerFactory(`An error occured when fetching ${thingToLoad}.`);

export const getFileAvailability = (runDate) =>
    axios.get('/SystemInfo/FileAvailability', { params: { runDate } })
        .then(r => r.data).catch(loadError('File Availability'));

const triggerDownload = (blob, filename) => {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
};

export const downloadFile = async (source, fileName) => {
    const response = await axios.get('/SystemInfo/FileAvailabilityDownload', {
        params: { source, fileName },
        responseType: 'blob'
    });
    triggerDownload(response.data, fileName);
};

export const downloadSourceZip = async (source, runDate) => {
    const response = await axios.get('/SystemInfo/FileAvailabilitySourceDownload', {
        params: { source, runDate },
        responseType: 'blob'
    });
    const date = runDate.replace(/-/g, '');
    triggerDownload(response.data, `biotic_${source}_${date}.zip`);
};

export const downloadAllFilesZip = async (runDate) => {
    const response = await axios.get('/SystemInfo/FileAvailabilityAllDownload', {
        params: { runDate },
        responseType: 'blob'
    });
    const date = runDate.replace(/-/g, '');
    triggerDownload(response.data, `biotic_all_${date}.zip`);
};
